//Copyright (c) 2024 Greener Power Solutions.
//This file is part of Greener Power Solutions' software,
//and may not be altered, copied, redistributed, or sold
//without specific permission.

export const combineDataOR = <R>(allData: R[][], uniqueEntityResolver: (item: R) => string | number): R[] => {
  return Array.from(new Map(allData.flat().map((item) => [uniqueEntityResolver(item), item])).values());
};

export const combineDataAND = <R>(
  allData: Array<R[] | { data: R[] }>,
  uniqueEntityResolver: (item: R) => string | number
): R[] => {
  const parsedData = allData.map((entry) => (Array.isArray(entry) ? entry : entry?.data || []));

  return parsedData.reduce((acc, current) => {
    const accSet = new Set(acc.map(uniqueEntityResolver));
    const currentSet = new Set(current.map(uniqueEntityResolver));
    const intersection = Array.from(accSet).filter((id) => currentSet.has(id));

    return acc.filter((item) => intersection.includes(uniqueEntityResolver(item)));
  }, parsedData[0] || []);
};
